import { DependenciesInjection } from "app/di/DependencyInjection";
import { AlertSupportImpl } from "../data/AlertSupportImpl";
import { IAlertSupportRepository } from "../domain/repositories/IAlertSupportRepository";
import { AlertSupportUseCase } from "../domain/useCases/AlertSupportUseCase";
import { VnskySupportAlertViewModel } from "../presentation/viewModel/VnskySupportAlertViewModel";
import { VnskySupportAlertToken } from "./VnskySupportAlertToken";

export class VnskySupportAlertInjection {
  static initInjections() {
    DependenciesInjection.register<VnskySupportAlertViewModel>(
      VnskySupportAlertToken.VnskySupportAlertViewModel,
      VnskySupportAlertViewModel,
      "viewModel",
    );
    DependenciesInjection.register<IAlertSupportRepository>(
      VnskySupportAlertToken.IAlertSupportRepository,
      AlertSupportImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AlertSupportUseCase>(
      VnskySupportAlertToken.AlertSupportUseCase,
      AlertSupportUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IAlertSupportRepository>(
      VnskySupportAlertToken.IAlertSupportRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<AlertSupportUseCase>(
      VnskySupportAlertToken.AlertSupportUseCase,
    );
  }
}
